export const FIRSTNAME_LENGTH = 20
export const LASTNAME_LENGTH = 20
export const DESIGNATION_LENGTH = 20
export const ORGANISATION_LENGTH = 20
export const CONTACT_LENGTH = 20

